import { Instance } from 'mobx-state-tree';
import { CustomerNotificationLogDtoModelBase } from './CustomerNotificationLogDtoModel.base';

/* The TypeScript type of an instance of CustomerNotificationLogDtoModel */
export interface CustomerNotificationLogDtoModelType extends Instance<typeof CustomerNotificationLogDtoModel.Type> {}

/* A graphql query fragment builders for CustomerNotificationLogDtoModel */
export { selectFromCustomerNotificationLogDto, customerNotificationLogDtoModelPrimitives, CustomerNotificationLogDtoModelSelector } from './CustomerNotificationLogDtoModel.base';

/**
 * CustomerNotificationLogDtoModel
 */
export const CustomerNotificationLogDtoModel = CustomerNotificationLogDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
